import { useMemo } from 'react';
import { useSales } from '../../api/hooks/sales/useSales';
import { ProviderTransitObligationBanner } from '../../components/atoms/ProviderTransitObligationBanner';
import { UpgradeRequiredBanner } from '../../components/atoms/UpgradeRequiredBanner';
import { EntityPaginationData } from '../../components/molecules/EntityPaginationData';
import { SORT_BY_SALES, SORT_DIRECTION, SUBSCRIPTION } from '../../interfaces/enumerables';
import { getSalesSortByFilter, getSalesTypeSelectionFilter } from '../../services/utils/sortData';
import { useHasActivePlan } from '../../services/utils/useHasActivePlan';
import { SalesItemCard } from './components/SalesItemCard';

export const SalesScreen = () => {
  const salesSortByFilter = useMemo(() => getSalesSortByFilter(), []);
  const salesTypeFilter = useMemo(() => getSalesTypeSelectionFilter(), []);
  const hasActivePlan = useHasActivePlan(false, SUBSCRIPTION.SIMPLE_V1);

  return (
    <EntityPaginationData
      useDataHook={useSales}
      ItemCardData={SalesItemCard}
      sortByFilter={salesSortByFilter}
      hideCreateButton={!hasActivePlan}
      sortByDefaultKey={SORT_BY_SALES.SENT_TO_AADE_AT}
      sortDirectionValue={SORT_DIRECTION.DESC}
      typeFilter={salesTypeFilter}
      headerSlot={
        <>
          {!hasActivePlan && <UpgradeRequiredBanner />}
          <div className="p-r-24 p-l-24 page-layout-1200 flex-center-center-row-nowrap">
            <ProviderTransitObligationBanner />
          </div>
        </>
      }
    />
  );
};
